<div dropdown>
    <a
        dropdownToggle
        data-toggle="dropdown"
        data-cy="HEADER_USER_MENU"
        class="header-icon d-flex align-items-center justify-content-center ml-2 cursor-pointer"
    >
        @if (impersonatorLogin()) {
            <span
                class="badge bg-warning text-dark su-login-badge me-2"
                data-cy="HEADER_SU_LOGIN_BADGE"
                [title]="'SU-Login durch {{login}}' | translate: { login: impersonatorLogin() }"
            >
                {{ 'SU-Login aktiv' | translate }}
            </span>
        }
        <p-avatar [label]="userLabel" styleClass="user-avatar me-2 me-lg-0 me-xl-0" size="large" shape="circle" />
        <!--        <em class="fas fa-user"></em>-->
    </a>
    <div
        *dropdownMenu
        class="dropdown-menu dropdown-menu-animated-right dropdown-lg bg-primary text-white float-right"
        id="userDropdown"
    >
        <div class="px-8">
            <div class="row">
                <div class="col padding-horizontal-20 padding-vertical-10 bg-secondary">
                    <div class="row align-items-center">
                        <div class="col-2">
                            <em class="fa fa-user-circle text-white"></em>
                        </div>
                        <div class="col-auto small">
                            {{ user.firstName }} {{ user.surName }}
                            @if (impersonatorLogin()) {
                                <div class="text-warning" data-cy="HEADER_SU_LOGIN_BY">
                                    {{ 'SU-Login durch {{login}}' | translate: { login: impersonatorLogin() } }}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div
                    class="col padding-horizontal-20 padding-vertical-10 user-menu-item"
                    [routerLink]="'/' + view + '/profile/settings'"
                >
                    <div class="row align-items-center">
                        <div class="col-2">
                            <em class="fa fa-user-cog text-white"></em>
                        </div>
                        <div class="col-auto small">
                            {{ 'Benutzereinstellungen' | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *showOnDev>
                <div class="col padding-horizontal-20 padding-vertical-10 user-menu-item" (click)="toggleDebug()">
                    <div class="row align-items-center">
                        <div class="col-2">
                            <em class="fa fa-cogs text-white"></em>
                        </div>
                        <div class="col-auto small">
                            {{ isDebug ? ('Debug deaktivieren' | translate) : ('Debug aktivieren' | translate) }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *featureActive="EprocFeature.REDIRECT_NEW_FRONTEND">
                <div
                    class="col padding-horizontal-20 padding-vertical-10 user-menu-item"
                    (click)="navigateToLegacyFrontend()"
                    data-cy="LEGACY_FRONTEND_BTN"
                >
                    <div class="row align-items-center">
                        <div class="col-2">
                            <em class="fa fa-external-link-alt text-white"></em>
                        </div>
                        <div class="col-auto small">
                            {{ 'Altes Frontend' | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div
                    class="col padding-horizontal-20 padding-vertical-10 user-menu-item"
                    (click)="logout()"
                    data-cy="LOGOUT_BTN"
                >
                    <div class="row align-items-center">
                        <div class="col-2">
                            <em class="fa fa-sign-out-alt text-white"></em>
                        </div>
                        <div class="col-auto small">
                            {{ 'Ausloggen' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
